import _ from 'lodash';

import { PROTOCOLE_IMPAYE_ORMC, PROTOCOLE_IMPAYE_PES_ASAP } from '@/constants/regie';
import type { CycleType } from '@/types';

/**
 * Détermine si la validation ordonnateur peut être activée/désactivée selon le protocole
 */
export const isValidationOrdonnateurDisabled = (
  protocole: string,
  cycleData: CycleType,
): boolean => {
  if (protocole === PROTOCOLE_IMPAYE_PES_ASAP) {
    // Si le cycle a été transféré,
    // Et s'il n'a pas encore été validé par le poste comptable,
    // on peut valider ou l'invalider ordonnateur
    if (cycleData.dateTransfertImpaye && _.isNil(cycleData.dateValidationPosteComptable)) {
      return false;
    }
  }

  if (protocole === PROTOCOLE_IMPAYE_ORMC) {
    // Si le cycle a son titre global transféré
    // Et si les impayés n'ont pas été transféré
    // Et s'il n'a pas encore été validé par le poste comptable,
    // on peut valider ou l'invalider ordonnateur
    if (cycleData.dateTransfertTitre && _.isNil(cycleData.dateValidationPosteComptable)) {
      return false;
    }
  }

  return true;
};

/**
 * Détermine si la validation poste comptable peut être activée/désactivée selon le protocole
 */
export const isValidationPosteComptableDisabled = (
  protocole: string,
  cycleData: CycleType,
): boolean => {
  if (protocole === PROTOCOLE_IMPAYE_PES_ASAP) {
    // Si le cycle a été transféré
    // Et s'il a été validé par l'ordonnateur
    // on peut valider ou invalider le poste comptable
    if (cycleData.dateTransfertImpaye && cycleData.validationOrdonnateur) {
      return false;
    }
  }

  if (protocole === PROTOCOLE_IMPAYE_ORMC) {
    // Si le cycle a eu ses impayés transférés
    // on peut valider ou invalider le poste comptable
    if (cycleData.dateTransfertImpaye) {
      return false;
    }
  }

  return true;
};
